
(() => {
  const mobile = matchMedia('(max-width: 749px)');
  const onReady = () => {
    const copy = document.getElementById('pt-mobile-copy')?.dataset;
    if (!copy) return;
    const section = document.querySelector('[id^="MainProduct-"]');
    const movedTabs = new Map();
    let framePending = false;
    let enhanceTimer;
    let busy = false;
    const visible = el => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).display !== 'none';
    const nativeButton = () => section && [...section.querySelectorAll('.product-form__buttons button[name="add"], .product-form__buttons button[type="submit"]')].find(el => visible(el) && el.textContent.trim());
    const sticky = section?.querySelector('.pooltime-sticky-buy');
    let proxy;
    if (sticky) {
      proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.className = 'pt-mobile-submit product-form__submit button button--primary btn-block';
      proxy.textContent = copy.add;
      proxy.addEventListener('click', () => {
        const original = nativeButton();
        if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true' || busy) return;
        const form = original.closest('form');
        if (form && !form.reportValidity()) { form.querySelector(':invalid')?.scrollIntoView({block:'center'}); return; }
        busy = true;
        proxy.disabled = true;
        original.click();
        setTimeout(() => { busy = false; requestUpdate(); }, 1200);
      });
      sticky.querySelector('.pooltime-sticky-button-slot')?.append(proxy);
      sticky.querySelector('[data-pooltime-scroll-options]')?.addEventListener('click', () => {
        const target = section.querySelector('.pooltime-config-heading, variant-selects, variant-radios, #itoris_dynamicproductoptions');
        target?.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      });
    }
    function updateSticky() {
      if (!sticky) return;
      // The purchase bar is hidden at the top. App hydration must not force
      // layout repeatedly before the customer has scrolled down the product.
      if (window.scrollY <= 0) {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
        sticky.inert = true;
        return;
      }
      const original = nativeButton();
      const price = section.querySelector('.pooltime-live-main-price');
      const rect = original?.getBoundingClientRect();
      const inlineVisible = rect && rect.top >= 0 && rect.bottom <= innerHeight - 8;
      const blocking = document.querySelector('cart-drawer.active, cart-notification.active, dialog[open], details.menu-opening');
      const show = !!price && price.getBoundingClientRect().bottom < (mobile.matches ? 80 : 70) && (!mobile.matches || !inlineVisible) && !blocking;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.inert = !show;
      proxy.disabled = busy || !original || original.disabled || original.getAttribute('aria-disabled') === 'true';
      const newLabel = original?.disabled ? original.textContent.trim() : copy.add;
      if (proxy.textContent !== newLabel) proxy.textContent = newLabel || copy.choose;
    }
    function requestUpdate() {
      if (framePending) return;
      framePending = true;
      requestAnimationFrame(() => { framePending = false; updateSticky(); });
    }
    function enhanceAssembly() {
      if (!section || !mobile.matches) return;
      section.querySelectorAll('#itoris_dynamicproductoptions .field').forEach(field => {
        const label = field.querySelector(':scope > label');
        if (!label || !/ihopsättning|montering|assembly|montage|asennus|összeszerel/i.test(label.textContent)) return;
        const list = field.querySelector('.options-list');
        if (!list?.querySelector('input[type="checkbox"]') || !/pooltak|pool enclosure|poolüberdachung|uima-altaan kate|medencefed/i.test(list.textContent)) return;
        field.classList.add('pt-assembly-field');
        const description = field.querySelector('.control > p');
        if (description && !field.querySelector('.pt-option-details')) {
          const details = document.createElement('details');
          details.className = 'pt-option-details';
          const summary = document.createElement('summary');
          summary.textContent = copy.details;
          description.before(details);
          details.append(summary,description);
        }
      });
    }
    function enhanceTabs() {
      document.querySelectorAll('.ppage-tab-item').forEach(root => {
        if (!mobile.matches) {
          root.classList.remove('pt-tabs-ready');
          root.querySelectorAll('.pt-tab-details').forEach(details => {
            const panel = details.querySelector('.tab-pane');
            if (panel && movedTabs.has(panel)) { const marker = movedTabs.get(panel); marker.replaceWith(panel); movedTabs.delete(panel); }
            details.remove();
          });
          return;
        }
        root.querySelectorAll(':scope > .nav-tabs .nav-item[data-id]').forEach(tab => {
          const panel = document.getElementById(tab.dataset.id);
          if (!panel || movedTabs.has(panel) || !panel.textContent.trim()) return;
          const marker = document.createComment('pt-mobile-tab'); panel.before(marker); movedTabs.set(panel,marker);
          const details = document.createElement('details'); details.className = 'pt-tab-details';
          const summary = document.createElement('summary'); summary.textContent = tab.textContent.trim();
          details.append(summary,panel); root.querySelector('.tab-content')?.append(details);
        });
        if (root.querySelector('.pt-tab-details')) root.classList.add('pt-tabs-ready');
      });
    }
    function enhance() {
      if (mobile.matches && section) {
        enhanceAssembly();
        section.querySelectorAll('.wbmeta_main > li').forEach(row => {
          const label = row.querySelector(':scope > span');
          if (label) row.classList.toggle('pt-empty-meta', row.textContent.trim() === label.textContent.trim());
        });
        const price = section.querySelector('.pooltime-live-main-price');
        if (price && !section.querySelector('.pt-mobile-price-note')) {
          const note = document.createElement('p'); note.className = 'pt-mobile-price-note'; note.textContent = copy.delivery; price.after(note);
        }
        const buttons = section.querySelector('.product-form__buttons');
        if (buttons && !section.querySelector('.pt-mobile-help')) {
          const help = document.createElement('a'); help.className = 'pt-mobile-help'; help.href = 'tel:+46102067060'; help.textContent = copy.help; buttons.after(help);
        }
      }
      enhanceTabs();
      requestUpdate();
    }
    if (section) {
      const scheduleEnhance = () => { clearTimeout(enhanceTimer); enhanceTimer = setTimeout(enhance,100); };
      new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('#itoris_dynamicproductoptions,.field,.options-list,.product-form__buttons,.pooltime-documents-pane') || node.querySelector?.('.options-list'))))) scheduleEnhance();
        requestUpdate();
      }).observe(section,{childList:true,subtree:true});
      section.addEventListener('change', () => { setTimeout(enhanceAssembly,0); requestUpdate(); });
      const externalTabs = document.querySelector('.ppage-tab-item');
      if (externalTabs && !section.contains(externalTabs)) new MutationObserver(records => {
        if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && n.matches?.('.nav-item,.tab-pane')))) scheduleEnhance();
      }).observe(externalTabs,{childList:true,subtree:true});
    }
    addEventListener('scroll',requestUpdate,{passive:true});
    addEventListener('resize',requestUpdate,{passive:true});
    document.addEventListener('click',() => setTimeout(requestUpdate,100));
    mobile.addEventListener('change', () => {
      if (!mobile.matches && sticky) sticky.inert = false;
      section?.querySelectorAll('.pt-option-details').forEach(details => { details.open = !mobile.matches; });
      enhance();
    });
    enhance();
    [400,1200,3000].forEach(delay => setTimeout(enhance,delay));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',onReady,{once:true}); else onReady();
})();

